import React, { useState } from 'react';

import { PrimaryButton } from '@components/Button/variants';
import Checkout from '@components/pages/SubscribeTest/Checkout';
import Experts from '@components/pages/SubscribeTest/OfferSelection/Experts';
import TheInformationDifference from '@components/pages/SubscribeTest/OfferSelection/TheInformationDifference';
import TheInformationPro from '@components/pages/SubscribeTest/OfferSelection/TheInformationPro';
import useEventTracking from '@hooks/useEventTracking';
import { Theme } from '@interfaces/global';
import { Page } from '@tracking';
import { OfferOption } from '@utils/backend-api/subscribe';
import { Reporter } from '@utils/backend-api/subscribe';

import { InsightArticle } from '.';
import Header from './Header';
import Insight from './Insight';
import Journalism from './Journalism';
import Offers from './Offers';
import { companies } from './constants';

enum LandingPage {
  OfferSelection = 1,
  Checkout = 2,
}

interface ContentProps {
  insightArticlesByTopic: InsightArticle[];
  offers: OfferOption[];
  reporters: Reporter[];
  ypOffer: OfferOption;
}

const Content = ({ insightArticlesByTopic, offers, reporters, ypOffer }: ContentProps) => {
  const { Track } = useEventTracking({ page: Page.AsiaTechCoverage });
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [currentPage, setCurrentPage] = useState(LandingPage.OfferSelection);

  const handleBackToTopClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Track>
      <div className="px-16 sm:px-28">
        {currentPage === LandingPage.OfferSelection && (
          <>
            <div className="md:max-w relative mx-auto w-full sm:max-w-[1174px]">
              <Header />
              <Offers
                ypOffer={ypOffer}
                offers={offers}
                onClickOffer={() => setCurrentPage(LandingPage.Checkout)}
                setSelectedOffer={setSelectedOffer}
              />
              <Insight insightArticlesByTopic={insightArticlesByTopic} />
              <div className="border-0 border-b border-solid border-b-grayscale-beige pb-80">
                <TheInformationDifference headerClass="not-italic" />
              </div>
              <Journalism />
              <div className="border-0 border-b border-t border-solid border-pro-gold">
                <TheInformationPro
                  className="!pt-0"
                  projectClassName="!border-grayscale-beige"
                  theme={Theme.Light}
                  companyLogos={companies}
                />
              </div>
            </div>
            <div>
              {reporters.length > 0 && (
                <Experts reporters={reporters} carouselClass="!max-w-[780px]" />
              )}
              <div className="mb-80 flex justify-center">
                <PrimaryButton
                  as="button"
                  onClick={handleBackToTopClick}
                  size="small"
                  className="mt-48 w-full xs:w-[496px] sm:mt-48"
                >
                  Back to top
                </PrimaryButton>
              </div>
            </div>
          </>
        )}
        {currentPage === LandingPage.Checkout && (
          <Checkout
            onBackClick={() => setCurrentPage(LandingPage.OfferSelection)}
            presentedOfferCodes={offers.map((offer) => offer.code)}
            selectedOffer={selectedOffer}
          />
        )}
      </div>
    </Track>
  );
};

export default Content;
